module.exports = "<span> <btn class=dropdown-button href=#! :data-activates=id :type=type :label=label :icon=icon :icon-position=iconPosition :large=large :waves-effect=false :light-wave=false :disabled=false></btn> <ul v-if=\"items.length > 0\" class=dropdown-content :id=id> <li v-for=\"item in items\" :class=\"item.divider ? 'divider' : ''\"> <a v-if=!item.divider :href=item.href>{{item.label}}<badge v-if=item.badge :label=item.badge.label :new=item.badge.new></badge></a> </li> </ul> <slot></slot> </span>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/dropdown/dropdown.vue
 ** module id = 80
 ** module chunks = 0
 **/